<template>
  <layout>
    <template v-slot:header>
      <AppHead :title="`Edit User ${form.first_name} ${form.last_name}`" />
      <h2>Edit User {{ form.first_name }} {{ form.last_name }}</h2>
      <BreadCrumbs activeItem="Edit User" :crumbs="{ home: 'Dashboard', users: 'Users'}"/>
      <flash-messages />
    </template>
        
    <template v-slot:default>
      <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore">
        This user has been deleted.
      </trashed-message>

      <form @submit.prevent="update">
        <div class="col-12 col-md-6 px-0">
          <card headerStyle="dark" title="User Info">
            <div class="form-group">
              <jet-label for="first_name" value="First name" />
              <jet-input id="first_name"  type="text" class="form-control" v-model="form.first_name" />
              <jet-input-error :message="form.errors.first_name" class="mt-2" />
            </div>
            <div class="form-group">
              <jet-label for="last_name" value="Last name" />
              <jet-input id="last_name"  type="text" class="form-control" v-model="form.last_name" />
              <jet-input-error :message="form.errors.last_name" class="mt-2" />
            </div>
            <div class="form-group">
              <jet-label for="email" value="Email" />
              <jet-input id="email"  type="text" class="form-control" v-model="form.email" />
              <jet-input-error :message="form.errors.email" class="mt-2" />
            </div>
          </card>
        </div>                  

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <jet-button v-if="!user.deleted_at" btnStyle="danger" class="mr-2 px-5 m-w-100 mb-2 mb-md-0" tabindex="-1" type="button" @click="destroy">Delete User</jet-button>
          <jet-button class="px-5 ml-auto m-w-100" btnStyle="success" icon="fas fa-shopping-cart" :disable="form.processing" type="submit">Update User</jet-button>
        </div>
      </form>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import TextInput from '@/Shared/TextInput'
  import FileInput from '@/Shared/FileInput'
  import SelectInput from '@/Shared/SelectInput'
  import TrashedMessage from '@/Shared/TrashedMessage'

  import JetButton from '@/Jetstream/Button'
  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import BreadCrumbs from '@/Shared/BreadCrumbs'

  export default {
    components: {
      FileInput,
      SelectInput,
      TextInput,
      TrashedMessage,
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      Layout,
      BreadCrumbs
    },
    props: {
      user: Object,
      roles: Object
    },
    remember: 'form',
    data() {
      return {
        form: this.$inertia.form({
          _method: 'put',
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          password: null,
          owner: this.user.owner,
          photo: null,
        }),
      }
    },
    methods: {
      update() {
        this.form.post(this.route('users.update', this.user.id), {
          onSuccess: () => this.form.reset('password', 'photo'),
        })
      },
      destroy() {
        if (confirm('Are you sure you want to delete this user?')) {
          this.$inertia.delete(this.route('users.destroy', this.user.id))
        }
      },
      restore() {
        if (confirm('Are you sure you want to restore this user?')) {
          this.$inertia.put(this.route('users.restore', this.user.id))
        }
      },
    },
  }
</script>
